export default[
    {
        path: '/tomador/lista',
        name: 'lista do tomadores', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/tomador/cadastro',
        name: 'cadastro do tomador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/tomador/editar/:id',
        name: 'editar tomador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]